<script>
    let { secret = "", mode = "text" } = $props();

    let revealed = $state(false);
    let obfuscated_secret = $derived("●".repeat(secret.length));
    let display_secret = $derived(revealed ? secret : obfuscated_secret);
    let buttonText = $derived(revealed ? "Hide" : "Reveal");

    function toggleSecret() {
        revealed = !revealed;
    }

    function copySecret() {
        navigator.clipboard.writeText(secret);
    }
</script>

{#if mode === "text"}
    <input type="text" name="secretHider" value={display_secret} readonly>
{:else}
    <textarea name="secretHider" value={display_secret} readonly></textarea>
    <br />
{/if}

<button onclick={toggleSecret} class="btn btn-primary">{buttonText}</button>
<button onclick={copySecret} class="btn btn-secondary">Copy</button>